import React, { useState, useContext, useEffect, useCallback } from "react";
import AuthContext from "../../context/AuthContext";
import {
  getProductosService,
  createProductoService,
  updateProductoService,
  deleteProductoService,
} from "../../utils/ProductoService";
import Paginator from "../paginator/Paginator";
import CreateProductoModal from "./CreateProductoModal";
import DeleteProductoButton from "./DeleteProductoButton";
import EditProductoModal from "./EditProductoModal";
import Loading from "../loading/Loading";

const TablaProductos = () => {
  const { authTokens } = useContext(AuthContext);
  const [productos, setProductos] = useState([]);
  const [displayProductos, setDisplayProductos] = useState([]);

  // States de la barra de busqueda.
  const [busqueda, setBusqueda] = useState("");
  const [busquedaResult, setBusquedaResult] = useState([]);

  // State Loading
  const [loading, setLoading] = useState(true);

  // Funciones encargadas de pedir info a la db.
  const getProductos = useCallback(async () => {
    const productos = await getProductosService(authTokens);
    setProductos(productos ?? []);
    setLoading(false);
  }, [authTokens]);

  

  const updateProducto = useCallback(async (id, producto) => {
    updateProductoService(id, producto, authTokens).then((response) => {
      const aux = productos.map((prod) => (prod.id === id ? response : prod));
      setProductos(aux);
    });
  });

  const deleteProducto = useCallback(
    async (id) => {
      await deleteProductoService(id, authTokens);
      const aux = productos.filter((producto) => producto.id !== id);
      setProductos(aux);
      setBusqueda("");
    },
    [authTokens, productos]
  );

  useEffect(() => {
    getProductos();
  }, [getProductos]);

  // Cada vez que 'busqueda' cambie, corremos search()
  useEffect(() => {
    search();
  }, [busqueda]);

  // Funcion que maneja el cambio en el campo de busqueda de productos
  const handleSearchChange = (search) => {
    setBusqueda(search);
  };

  // Funcion que maneja la busqueda
  const search = () => {
    // Si se escribio algo en busqueda filtramos sobre todos los productos
    let aux = productos.filter((producto) =>
      getFullName(producto).includes(busqueda.toLocaleLowerCase())
    );
    setBusquedaResult(aux);
  };

  const getFullName = (producto) => {
    return (
      producto.producto.toLowerCase() +
      " " +
      producto.marca.toLowerCase() +
      " " +
      producto.marca.toLowerCase() +
      " " +
      producto.producto.toLowerCase()
    );
  };

  return (
    <div>
      <div className="row">
        <div className="mt-4  d-flex justify-content-start">
          {" "}
          <h4>Productos </h4>{" "}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 py-4 col-sm-12 d-flex justify-content-start">
          <CreateProductoModal productos={productos} setProductos={setProductos} />
        </div>
        <div className="col-lg-10 col-sm-12">
          <div className="input-group input-group-sm my-4">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar producto por nombre o marca."
              value={busqueda}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => setBusqueda("")}
                type="button"
              >
                {busqueda ? "Borrar" : "Buscar"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-sm table-hover table-dark">
              <caption>Listado de Productos</caption>
              <thead>
                <tr>
                  <th className="col-3">Producto</th>
                  <th className="col-2">Marca</th>
                    <th className="col-lg-2">Precio</th>
                    <th className="col-lg-2">P/Tarjeta</th>
                  <th className="col-lg-1">Stock</th>
                  <th className="col-lg-2">Accion</th>
                </tr>
              </thead>

              <tbody>
                {busqueda.length > 0
                  ? busquedaResult.map((producto) => {
                      return (
                        <tr key={producto.id} className="table-light ">
                          <td>{producto.producto}</td>
                          <td>{producto.marca}</td>
                          <td>${producto.precio}</td>
                          <td>${producto.tarjeta}</td>
                          <td>
                            {producto.stock > 0 ? (
                              producto.stock + "u"
                            ) : (
                              <span className="badge bg-danger">Sin Stock</span>
                            )}
                          </td>
                          <td>
                            <EditProductoModal
                              producto={producto}
                              updateProducto={updateProducto}
                              setBusqueda={setBusqueda}
                            />
                            <DeleteProductoButton
                              id={producto.id}
                              deleteProducto={deleteProducto}
                              setProductos={setProductos}
                            />
                          </td>
                        </tr>
                      );
                    })
                  : displayProductos.map((producto) => {
                      return (
                        <tr key={producto.id} className="table-light ">
                          <td>{producto.producto}</td>
                          <td>{producto.marca}</td>
                          <td>${producto.precio}</td>
                          <td>${producto.tarjeta}</td>
                          <td>
                            {producto.stock > 0 ? (
                              producto.stock + "u"
                            ) : (
                              <span className="badge bg-danger">Sin Stock</span>
                            )}
                          </td>
                          <td>
                            <EditProductoModal
                              producto={producto}
                              updateProducto={updateProducto}
                              setBusqueda={setBusqueda}
                            />
                            <DeleteProductoButton
                              id={producto.id}
                              deleteProducto={deleteProducto}
                              setProductos={setProductos}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
          <br />
          <Paginator items={productos} setDisplayItems={setDisplayProductos} />
        </>
      )}
    </div>
  );
};

export default TablaProductos;
